/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Text, FontIcon } from '@bingads-webui-react/fabric-control';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { ClipchampPlayer } from '@bingads-webui-campaign-react/clipchamp-player';
import { Link } from '../common/shared-components';
import { getAdsStepStyles } from './styles';

const ITEMS_PER_PAGE = 10;

export const AdPreview = (props) => {
  const {
    i18n,
    ads,
    onUpdateCurrentVideoIndex,
    disablePagination,
    customStyleFunction,
    useCustomStyleFunction,
    permissions,
    loadClipchampPlayer,
  } = props;

  const videos = (ads && ads.data && _.isArray(ads.data)) ? ads.data : [];

  const videoRef = useRef();

  const defaultClasses = useDefaultStyles(getAdsStepStyles);

  const customClasses = useDefaultStyles(customStyleFunction);

  const classes = useCustomStyleFunction ? customClasses : defaultClasses;

  const { currentPageIndex } = ads;

  const [currentVideoIdx, setCurrentVideoIdx] = useState(0);

  const [videoHeight, setVideoHeight] = useState('280'); // default 280 height for horizontal videos
  const videoTemplateUIEnabled = permissions && permissions.dynamic && permissions.dynamic.VideoTemplateUI;

  const getPageAdjustedIndex = (idx, pageNumber = null) => {
    const page = pageNumber || currentPageIndex;

    const val = (((page - 1) * ITEMS_PER_PAGE) + idx);

    return val;
  };

  const goToPrevVideo = () => {
    setCurrentVideoIdx(currentVideoIdx - 1);
  };

  const goToNextVideo = () => {
    setCurrentVideoIdx(currentVideoIdx + 1);
  };

  const goToVideoIndex = (idx) => {
    setCurrentVideoIdx(idx);
  };

  const videosInPage = videos.slice(getPageAdjustedIndex(0), getPageAdjustedIndex(9) + 1);

  const currentVideo = videos[getPageAdjustedIndex(currentVideoIdx)] || videos[0];

  useEffect(() => {
    setCurrentVideoIdx(0);
  }, [currentPageIndex]);

  useEffect(() => {
    if (currentVideoIdx > videosInPage.length - 1) {
      setCurrentVideoIdx(0);
    }
    onUpdateCurrentVideoIndex(currentVideoIdx);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentVideoIdx, videosInPage.length]);

  const source = (currentVideo && currentVideo.data && currentVideo.data.video && currentVideo.data.video.src) || '';

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
    }
  }, [source]);


  useEffect(() => {
    if (currentVideo?.data?.video) {
      const { height, width } = currentVideo.data.video;
      const isVertical = height > width;

      if (isVertical) {
        setVideoHeight('420');
      } else {
        setVideoHeight('280');
      }
    }
  }, [currentVideo]);

  return (
    <div className={classes.adPreviewRoot}>
      <div className={classes.adPreviewHeader}>
        <Text className={classes.adPreviewTitle}> {i18n.getString(_TL_('Ad preview'))} </Text>
      </div>
      <div className={classes.previewContainer}>
        {videoTemplateUIEnabled ? (
          <div style={videoHeight === '420' ? { width: '260px' } : {}}>
            <ClipchampPlayer videoUrl={source} width="100%" loadClipchampPlayer={loadClipchampPlayer} i18n={i18n} />
          </div>
        ) : (
          <video className={classes.video} height={videoHeight} width="100%" controls ref={videoRef}>
            <source src={source} />
          </video>
       )}
      </div>
      {
        !disablePagination && videosInPage.length > 1 && (
        <div className={classes.pagination}>
          <div className={classes.pageControls} style={{ justifyContent: 'space-between' }}>
            <Link
              onClick={goToPrevVideo}
              disabled={currentVideoIdx === 0}
            >
              <FontIcon iconName="ChevronLeft" /> <Text> {i18n.getString(_TL_('Previous ad'))} </Text>
            </Link>
            <div className={classes.paginationIndicator}>
              {
            videosInPage.map((video, idx) => (
              <div>
                <span onKeyDown={() => goToVideoIndex(idx)} onClick={() => goToVideoIndex(idx)} className={classes.paginationIndicatorDot} style={{ backgroundColor: getPageAdjustedIndex(idx) === getPageAdjustedIndex(currentVideoIdx) ? '#0078d4' : '#c8c6c4' }} />
              </div>
            ))
          }
            </div>
            <Link
              onClick={goToNextVideo}
              disabled={currentVideoIdx === videosInPage.length - 1 || videosInPage.length === 0}
            >
              <Text> {i18n.getString(_TL_('Next ad'))} </Text> <FontIcon iconName="ChevronRight" />
            </Link>
          </div>
        </div>
        )
      }
      <div className={classes.previewTag}>
        <Text>
          {i18n.getString(_TL_('This is an example of what your video ad might look like. Depending on placement, the actual ad shown may appear differently.'))}
        </Text>
      </div>
    </div>
  );
};

AdPreview.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  ads: PropTypes.shape({
    data: PropTypes.instanceOf(Array),
    currentPageIndex: PropTypes.number,
  }).isRequired,
  disablePagination: PropTypes.bool,
  onUpdateCurrentVideoIndex: PropTypes.func.isRequired,
  customStyleFunction: PropTypes.func,
  useCustomStyleFunction: PropTypes.bool,
  loadClipchampPlayer: PropTypes.func,
};

AdPreview.defaultProps = {
  disablePagination: false,
  customStyleFunction: _.noop,
  useCustomStyleFunction: false,
  loadClipchampPlayer: _.noop,
};
